import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPurchases } from '../store/paymentSlice';
import { fetchAllBalances } from '../store/walletSlice';
import api from '../api';

export default function PaywallOverlay({ content, onUnlock }) {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { allBalances } = useSelector((state) => state.wallet);
  const [purchasing, setPurchasing] = useState(false);
  const [error, setError] = useState(null);

  const handlePurchase = async () => {
    setPurchasing(true);
    setError(null);

    try {
      await api.post('/payment/pay', { contentId: content.id });

      // Unlock immediately — don't wait for store refreshes
      if (onUnlock) onUnlock();

      // Refresh state in background
      dispatch(fetchPurchases());
      setTimeout(() => dispatch(fetchAllBalances()), 2000);
      setTimeout(() => dispatch(fetchAllBalances()), 5000);
    } catch (err) {
      const msg = err.response?.data?.error || 'Purchase error';
      setError(msg);
      setPurchasing(false);
    }
  };

  const bal = allBalances?.totalBalance ? parseFloat(allBalances.totalBalance) : 0;
  const price = parseFloat(content.price_usdc);
  const hasWallet = !!user?.walletAddress || !!user?.custodialAddress || bal > 0;
  const hasBalance = bal >= price;

  return (
    <div className="paywall-overlay">
      <div className="paywall-content">
        <h3>Preview ended</h3>
        <p>Support the creator and watch the full version</p>
        <div className="paywall-price">{parseFloat(parseFloat(content.price_usdc).toFixed(2))} $</div>
        {user && <div className="paywall-balance">Your balance: {parseFloat(bal.toFixed(2))} $</div>}

        {!user ? (
          <div>
            <p className="paywall-hint">Sign up and fund your wallet to watch the full version</p>
            <div className="paywall-actions">
              <a href="/register" className="btn btn-primary">Create Account</a>
              <a href="/login" className="btn btn-secondary">I have an account</a>
            </div>
          </div>
        ) : !hasWallet ? (
          <div>
            <p className="paywall-hint">Link your wallet and deposit to purchase</p>
            <a href="/wallet" className="btn btn-primary">Go to Wallet</a>
          </div>
        ) : !hasBalance ? (
          <div>
            <p className="paywall-hint">Insufficient balance. Deposit to purchase.</p>
            <a href="/wallet" className="btn btn-primary">Add funds</a>
          </div>
        ) : (
          <button onClick={handlePurchase} disabled={purchasing} className="btn btn-primary">
            {purchasing ? (<><span className="paywall-spinner" /> Processing payment...</>) : 'Pay and watch full'}
          </button>
        )}
        {error && (
          <>
            <div className="error-msg">{error}</div>
            <button onClick={() => { setError(null); setPurchasing(false); }} className="btn btn-secondary" style={{ marginTop: 8 }}>
              Try again
            </button>
          </>
        )}
      </div>
    </div>
  );
}
